import useMenuItemEr from './useMenuItemEr.jsx'

export default () => {
    const menuItemEr = useMenuItemEr()

    return (map, nodes) => [
        menuItemEr(map, nodes)
    ]
}
